import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import imageCompression from 'browser-image-compression';
import { Modal, Button } from 'antd';

const ImageCropModal = ({ visible, imageSrc, onClose, onDone }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onCropComplete = useCallback((_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

     const getCroppedCircularImage = (imageSrc, crop) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.src = imageSrc;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = crop.width;
                canvas.height = crop.height;
                const ctx = canvas.getContext('2d');

                ctx.beginPath();
                ctx.drawImage(
                    image,
                    crop.x,
                    crop.y,
                    crop.width,
                    crop.height,
                    0,
                    0,
                    crop.width,
                    crop.height
                );

                canvas.toBlob(blob => {
                    if (!blob) {
                        reject(new Error('Erro ao criar blob'));
                    } else {
                        resolve(blob);
                    }
                }, 'image/webp', 0.9);
            };

            image.onerror = () => reject(new Error('Erro ao carregar imagem'));
        });
    }


    const handleFinish = async () => {
        try {
            setLoading(true);
            const croppedBlob = await getCroppedCircularImage(imageSrc, croppedAreaPixels);

            const compressedBlob = await imageCompression(croppedBlob, {
                maxSizeMB: 3,
                fileType: 'image/webp',
                useWebWorker: true,
            });

            onDone(compressedBlob);
            onClose();
        } catch (err) {
            console.error('Erro ao processar imagem:', err);
            setError('Erro ao processar imagem');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Ajustar imagem"
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>Cancelar</Button>,
                <Button key="ok" type="primary" loading={loading} onClick={handleFinish}>
                    Confirmar
                </Button>,
            ]}
        >
            <div style={{ position: 'relative', width: '100%', height: 300 }}>
                <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    cropShape="round"
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                />
            </div>
        </Modal>
    );
};

export default ImageCropModal;
